import { Component, Input, OnInit } from "@angular/core";
import { BaseClass } from "src/app/shared/classes/base";
import { ToastController } from "@ionic/angular";
import { TranslationService } from "src/app/shared/services/translation.service";
import { AxiConfiguration } from "src/app/calibration/components/calibration-nine-box/models/axi.model";
import { ConfigService } from 'src/app/shared/services/multi-clients/config.service';

@Component({
    selector: "app-preview-ninebox",
    templateUrl: "./preview-ninebox.modal.html",
    styleUrls: ["./preview-ninebox.modal.scss"],
})
export class PreviewNineBoxModal extends BaseClass implements OnInit {
    private _xValue: number;
    private _yValue: number;
    private _nineboxConfig: AxiConfiguration;
    public invertedQuadrants = [1, 4, 7, 2, 5, 8, 3, 6, 9];
    public hasInvertedQuadrants: boolean;
    public isMinimized: boolean = false;

    @Input()
    set nineboxConfig(value: AxiConfiguration) {
        this._nineboxConfig = value;
        this.xLength = value.xAxis.values.length;
        this.yLength = value.yAxis.values.length;
    }
    get nineboxConfig(): AxiConfiguration {
        return this._nineboxConfig;
    }

    @Input()
    set xValue(value: number) {
        this._xValue = value;
        this.calculateQuadrant();
    }
    get xValue(): number {
        return this._xValue;
    }

    @Input()
    set yValue(value: number) {
        this._yValue = value;
        this.calculateQuadrant();
    }
    get yValue(): number {
        return this._yValue;
    }
    public activeQuadrant: number = 0;
    public xLength: number = 0;
    public yLength: number = 0;

    constructor(
        protected _toastController: ToastController,
        protected _translationService: TranslationService,
        private _configService: ConfigService
    ) {
        super(_toastController, _translationService);
    }

    async ngOnInit() {
        this.hasInvertedQuadrants = this._configService.settings.features.nineBox.invertedQuadrants;
    }

    public getQuadrantNumber(row: number, column: number): number {
        return 1 + row + 3 * column;
    }

    public calculateQuadrant() {
        if (!this.nineboxConfig || !this.xValue || !this.yValue) return;
        const row = this.nineboxConfig.xAxis.values.findIndex((value) => this.xValue >= value.min && this.xValue < value.max);
        const column = this.nineboxConfig.yAxis.values.findIndex((value) => this.yValue >= value.min && this.yValue < value.max);
        this.activeQuadrant = this.getQuadrantNumber(row, column);
    }

    toggleMinimize(): void {
        this.isMinimized = !this.isMinimized;
    }
}
